import { DEFAULT_LANGUAGE } from "@src/constants/constants";
import SignolUtils from "@src/utils/signolUtils";

/** @returns {Promise<{ data: {language: string, industry: string, dynamic_content: Record<string, Array<{content_value: string, replacements?: string[]}>>, global_inherited: Record<string, boolean>, industry: string, language: string }}>} */
async function getDynamicContentResp(
  language = DEFAULT_LANGUAGE,
  industry = SignolUtils.getIndustry() || "aviation",
) {
  const errors = [];
  //Method 1: Get via HTTP (Good for QA and Prod)
  try {
    const response = await fetch(`/i18n/${industry}.${language}.json`);
    const json = await response.json();

    if (json?.data?.dynamic_content != null) {
      return json;
    }
  } catch (fetchError) {
    errors.push(`Error fetching JSON for ${industry}.${language}:`, fetchError);
  }

  //Method 2: Get locally (Good for Demo and Local)
  try {
    const module = await import(`./${industry}.${language}.json`);
    return module?.default ?? module;
  } catch (importError) {
    errors.push(
      `Error importing gero local ${industry}.${language}.json:`,
      importError,
    );
  }

  //Fallback if the above failed
  console.error(
    `Error importing Dynamic Content for ${industry}.${language}:`,
    errors,
  );
  return {
    data: {
      industry,
      language,
      dynamic_content: {},
      global_inherited: {},
    },
  };
}

export { getDynamicContentResp };
